import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionFlowService } from 'src/app/core/services/action-flow.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-redirecting',
  templateUrl: './redirecting.component.html',
  styleUrls: ['./redirecting.component.scss'],
})
export class RedirectingComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private actionFlowService: ActionFlowService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // Small delay to ensure the UI renders before the heavy lifting of the next route guards starts
    setTimeout(() => {
      this.enterApp();
    }, 100);
  }

  async enterApp(): Promise<void> {
    const queryRedirect = this.route.snapshot.queryParams['redirectTo'];
    const localRedirect = localStorage.getItem('postLoginRedirect');

    const redirectPath = queryRedirect || localRedirect;

    console.log('redirecting -> enter app', { redirectPath, queryRedirect, localRedirect });

    if (localRedirect) {
      localStorage.removeItem('postLoginRedirect');
    }

    if (this.isInternalPath(redirectPath)) {
      // Recalcula a action pendente de verdade em vez de confiar cegamente no
      // destino estático (evita reabrir uma questionnaire/link já concluído, CPK-4246)
      const user = await this.userService.getCurrentUser();
      const resolvedPath = await this.actionFlowService.resolvePendingActionRedirect(
        redirectPath,
        user?.id
      );
      this.router.navigateByUrl(resolvedPath);
    } else {
      this.router.navigateByUrl('/client');
    }
  }

  private isInternalPath(path: string | null): path is string {
    return !!path && path.startsWith('/') && !path.startsWith('//');
  }
}
